import React from "react";
import { Link } from "react-router-dom";
import useRemoteTemplate from "../../../../hooks/queryResults/remote/useRemoteTemplate";
import AdminRemoteConfigForm from "./AdminRemoteConfigForm";

export default function AdminRemoteConfigEdit() {
  const template = useRemoteTemplate();

  return (
    <>
      <h1>
        <Link to={"/remote/admin"}>Admin</Link> - Remote - Config Edit
      </h1>
      {!template ? (
        "loading..."
      ) : (
        <AdminRemoteConfigForm config={template.config} />
      )}
    </>
  );
}
